
<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 1100px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div style>
        <div class="col-xs-1">
          <!-- <img
            src="../../assets/imgs/png/FAJRLOGO01.png"
            style="float: left; height: 90px; width: 130px"
          /> -->
        </div>
        <div class="col-xs-8">
          <h3
            style="
              font-weight: 500;
              margin-top: 60px;
              font-size: 28px;
              font-family: 'Roboto Slab', serif;
            "
          >
            PAYMENT OBLIGATION TRANSFER
          </h3>
        </div>
        <div class="col-xs-3">
          <img
            :src="BankLogo"
            style="float: right; height: 44px; width: 195px"
          />
        </div>
      </div>
      <br clear="all" />
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1.2px solid #b35900" />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-1" style="font-weight: bold">Date:</div>
          <div class="col-xs-11">
            {{ Timestrap(Request.ApplicationDate) }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-1" style="font-weight: bold">To:</div>
          <div class="col-xs-11">Fajr Investment Advisory B.S.C (c)</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-1" style="font-weight: bold">From:</div>
          <div class="col-xs-11">
            {{ Request.BankName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-1" style="font-weight: bold">Cc:</div>
          <div class="col-xs-11">
            {{ Request.PurchaserName }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-1" style="font-weight: bold">Subject:</div>
          <div class="col-xs-11">
            Payment Obligation Transfer from {{ Request.BankName }} to Ashton
            Commodities Limited
          </div>
        </div>
      </div>

      <hr style="border: 1px solid #b35900; margin-top: 5px" />

      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            We refer to the Master Sale Agreement between us on
            <b>{{ AggrementDate }}</b> and the Transaction
            <b>{{ Request.RefNo }}</b>
            which was concluded under the Master Sale Agreement on
            <b> {{ DateFromat(Request.ApplicationDate, true) }}</b
            >.
            <br />
            <br />

            In reference to the Spot Sale of the Transaction
            <b>{{ Request.RefNo }}</b>
            which was concluded between
            <b> {{ Request.BankName }}</b> and
            <b> {{ Request.PurchaserName }}</b> on
            <b> {{ DateFromat(Request.ApplicationDate, true) }}</b
            >. We would like to inform you that we have transferred our payment
            obligation for the Purchase Price of the commodity we bought from
            you to <b> {{ Request.PurchaserName }}</b>

            <br />
            <br />
            The terms used for the Spot Sale Transaction are as follows:
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: -15px">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Commodity:</div>
          <div class="col-xs-7">{{ Request.CommodityName }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Quantity:</div>
          <div class="col-xs-7">
            {{ Request.StringQuantity }} {{ Request.UnitName }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Unit Price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringUnitPrice }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Settlement Date:</div>
          <div class="col-xs-7">{{ DateFromat(Request.ValueDate, true) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Sale price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringAmount }}
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              The acceptance of this transfer notice exempts
              <b>{{ Request.BankName }}</b> from its obligation of paying the
              Total Price of the commodity referred to above.
            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <br />For and on behalf of
            <br />
            <b>{{ Request.BankName }}</b>
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <p style="text-align: center; font-size: 10px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 16px; text-align: center; margin-top: -30px">
        <br />Riyadh, Kingdom of Saudi Arabia, www.alinmacapital.com
      </p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-size: 18px;
}
</style>

  <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      AggrementDate: "GETAGGREMENTDATE",
      BankLogo: "GETBANKLOGO",
    }),
  },
};
</script>
<style scopped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 26%;
}
</style>
